import * as React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {
    FMCollapseExpand,
    FMTreeNode,
    FMTreeGroupNodeWithStore,
    FMIcon,
} from 'atoms';
import style from './Nodes.style';
import { GroupProps } from '../../organisms/FMTree/TypesForNodes';

class FMTreeGroupNode extends React.Component<GroupProps> {

    public render() {
        return (
            <React.Fragment>
                <FMTreeNode
                    level={this.props.level}
                    selected={this.props.selected}
                    selectNode={this.props.selectNode}
                >
                    {
                        (this.props.childGroups.length > 0) &&
                            <FMCollapseExpand
                                checked={this.props.expanded}
                                onClick={this.props.expanded ? this.props.collapseGroup : this.props.expandGroup}
                            />
                    }
                    {
                        (this.props.childGroups.length === 0) &&
                            <FMIcon type="empty" />
                    }
                    <div className={this.props.classes.nodeName} >
                        {this.props.name}
                    </div>
                </FMTreeNode>
                {
                    this.props.expanded && this.props.childGroups.map(id =>
                        <ConnectedFMTreeGroupNodeWithStyles
                            {...this.props}
                            key={id}
                            id={id}
                            level={this.props.level + 1}
                        />
                    )
                }
            </React.Fragment>
        );
    }

}

const ConnectedFMTreeGroupNodeWithStyles = withStyles(style)(FMTreeGroupNodeWithStore(FMTreeGroupNode));

export default ConnectedFMTreeGroupNodeWithStyles;
